import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { SwitchConfigurationComponent } from '../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { P00037DureeInversion } from '../../Enum/P00037DureeInversion';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { P0003607ESPPolariteComponent } from '../../../P0003607/Electrolyseur/EnSavoirPlus/p0003607-esppolarite/p0003607-esppolarite.component';
import { SlideModalController } from '../../../../../../slide-modal.service';
import { TwoChoicesModalComponent } from '../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { P0003607PositionTypeEnum } from '../../../P0003607/Enum/P0003607PositionTypeEnum';
import { P00037PositionTypeEnum } from '../../Enum/P00037PositionTypeEnum';
import { P00037ESPPolariteComponent } from '../../EnSavoirPlus/p00037-esppolarite/p00037-esppolarite.component';

@Component({
  selector: 'app-p00037-installation-cellule',
  templateUrl: './p00037-installation-cellule.component.html',
  styleUrls: ['./p00037-installation-cellule.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    TranslatePipe,
    SwitchConfigurationComponent,
    LabelDescriptionComponent,
    LargedLinkComponent,
  ],
})
export class P00037InstallationCelluleComponent implements OnInit {
  private slideModalController = inject(SlideModalController);
  private modalController = inject(ModalController);
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  public currentForm: FormGroup | null = null;
  private fb = inject(FormBuilder);

  constructor() {
    this.P00037ESPPolarite = this.P00037ESPPolarite.bind(this);
  }

  async P00037ESPPolarite() {
    const modal = await this.slideModalController.create({
      component: P00037ESPPolariteComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );

    this.initForm();
  }

  async openModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P00037.modal.positiontype.title',
        value: this.currentForm!.controls['position'].value,
        firstChoice: {
          title: 'P00037.modal.positiontype.option0',
          image:
            '/assets/ecosystem/images/products/P00037/P00037-positioncellule-0.png',
          value: 0,
        },
        secondChoice: {
          title: 'P00037.modal.positiontype.option1',
          image:
            '/assets/ecosystem/images/products/P00037/P00037-positioncellule-1.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.currentForm!.controls['position'].setValue(data.value);
    }
  }

  private initForm() {
    this.currentForm = this.fb.group({
      position: [this.poolAdditionalData?.positionCelluleSalt ?? 0, []],
    });
  }

  onSubmit() {
    this.poolAdditionalData!.positionCelluleSalt =
      this.currentForm!.controls['position']?.value;

    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00037DureeInversion = P00037DureeInversion;
  protected readonly P0003607PositionTypeEnum = P0003607PositionTypeEnum;
  protected readonly P00037PositionTypeEnum = P00037PositionTypeEnum;
}
